import { lazy } from 'react';
import { createBrowserRouter, Navigate } from 'react-router-dom';

import { APP_WEB_ROUTES } from './consts/routes';
import RequireAuthRoute from './RequireAuthRoute';
import Root from './Root';

const LoginPage = lazy(() => import('../../src/pages/Login'));

const LoanListsPage = lazy(() => import('../../src/pages/LoanLists'));
const LoanListItemPage = lazy(() => import('../../src/pages/LoanListItem'));
const LoanDetailsPage = lazy(() => import('../../src/pages/LoanDetails'));
const LoanListCreatePage = lazy(() => import('../pages/LoanLists/components/LoanListCreate'));
const LoanListEditPage = lazy(() => import('../pages/LoanLists/components/LoanListEdit'));
const CustomerPaymentsPage = lazy(() => import('../../src/pages/CustomerPayments'));

const router = createBrowserRouter([
  {
    path: APP_WEB_ROUTES.root,
    element: (
      <RequireAuthRoute>
        <Root />
      </RequireAuthRoute>
    ),
    children: [
      {
        path: '',
        element: <Navigate to={APP_WEB_ROUTES.loans} />,
      },
      {
        path: APP_WEB_ROUTES.loans,
        element: <LoanListsPage />,
      },
      {
        path: APP_WEB_ROUTES.loanListCreate,
        element: <LoanListCreatePage />,
      },
      {
        path: APP_WEB_ROUTES.loan,
        element: <LoanListItemPage />,
      },
      {
        path: APP_WEB_ROUTES.loanDetails,
        element: <LoanDetailsPage />,
      },
      {
        path: APP_WEB_ROUTES.loanListEdit,
        element: <LoanListEditPage />,
      },
      {
        path: APP_WEB_ROUTES.paymentPlan,
        element: <CustomerPaymentsPage />,
      },
      {
        path: APP_WEB_ROUTES.users,
        element: <></>,
      },
      {
        path: APP_WEB_ROUTES.notifications,
        element: <></>,
      },
      {
        path: APP_WEB_ROUTES.settings,
        element: <></>,
      },
      {
        path: APP_WEB_ROUTES.reports,
        element: <></>,
      },
    ],
  },
  {
    path: APP_WEB_ROUTES.login,
    element: <LoginPage />,
  },
]);

export default router;
